<template>
  <Sider
    class="app-sider"
    v-if="!appBreakpoint"
    breakpoint="xs"
    :width="216"
    hide-trigger
    collapsible
    :collapsed-width="64"
    v-model="collapsed">
    <AppMenu />
  </Sider>
</template>
<script>
export default {
  computed: {
    appBreakpoint () {
      return this.$store.state.appBreakpoint
    },
    collapsed: {
      get () {
        return this.$store.state.isCollapsed
      },
      set (value) {
        this.$store.commit('updateCollapsed', value)
      }
    }
  }
}
</script>
<style lang="less">
  @import '../../assets/less/base/variables.less';
  .app-sider {
    position: fixed;
    z-index: 4;
    left: 0;
    top: 0;
    bottom: 0;
    min-height: 100vh;
    background: @darker;
    transition: all @animation-time;
  }
</style>
